export default 'fonts/460cc647c4a5a3487b62fc1cabf44770.woff2';